import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import SEO from '../src/components/SEO';
import Content from '../src/views/Content';
import pageContextType from '../src/types/pageContextType';
import TemporaryLayout from '../src/layouts/temporary';

const isPreview = process.env.NODE_ENV === 'development';

const PageTemplate = (props) => {
    return (
        <TemporaryLayout
            isPreview={isPreview}
            extendPageData={(pageData) => {
                pageData.otherLangPath = '/sitemap';
                return pageData;
            }}
            {...props}
        >
            <Content key={uniqueId()} isSitemapPage={true} />
        </TemporaryLayout>
    );
};



export default PageTemplate;

export const Head = ({ pageContext }) => <SEO pageContext={pageContext} pageData={{
    langcode: pageContext.langcode,
    path: {
        alias: '/sitemap'
    }
}} />;

PageTemplate.propTypes = {
    pageContext: PropTypes.shape(pageContextType).isRequired
};
